import { useEffect, useState } from "react";
import apiMethod from "../../services/api-service";
import methods from "../../services/utility";
import Preloading from "../../components/basics/Preloading";
import { Link, Navigate } from "react-router-dom";
import ResturantHeader from "../../components/header/ResturantHeader";

const Resturants = () => {
  const [loading, setLoading] = useState(false);
  const [gridData, setGridData] = useState([]);
  const isUserLogedin = methods.checkUserLogin();

  const getResturants = async () => {
    setLoading(true);
    const resp = await apiMethod.getUserRestaurants();
    if (methods.showApiErrors(resp)) setGridData(resp.data);
    setLoading(false);
  };

  useEffect(() => {
    const bindData = async () => {
      await getResturants();
    };
    bindData();
  }, []);

  const renderItems = () => {
    return (
      <>
        {loading && <Preloading></Preloading>}
        {
          <div
            className="w-100 my-5"
            style={{
              height: "100vh",
              width: "100%",
              maxWidth: "1000px",
              margin: "0 auto",
            }}
          >
            <div className="d-flex flex-column gap-4">
              <h3>لیست رستوران ها</h3>
              <span>رستوران مورد نظر خود را انتخاب نمایید</span>
            </div>

            <div className="row mt-4">
              {gridData.map((item) => (
                <Link
                  key={item.id}
                  to={`/${item.id}/dashboard`}
                  className="col-6"
                >
                  {/* <button className="btn btn-outline-purple btn-lg">
                    {item.title}
                  </button> */}
                  <div key={item.id}>
                    <div className="card">
                      <div className="card-body">
                        <button
                          type="button"
                          id="branchTitle"
                          className="btn custome-btn btn-link-purple w-100 mt-3"
                        >
                          رستوران {item.title}
                        </button>
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        }
      </>
    );
  };
  return (
    <div>
      {isUserLogedin ? (
        <>
          {<ResturantHeader />}
          {renderItems()}
        </>
      ) : (
        <Navigate to="/login" />
      )}
    </div>
  );
};

export default Resturants;
